import React from 'react';

interface FormWrapperProps {
  title: string;
  subtitle: string;
  currentStep: number;
  totalSteps: number;
  children: React.ReactNode;
}

const FormWrapper: React.FC<FormWrapperProps> = ({ title, subtitle, currentStep, totalSteps, children }) => {
  const renderStepper = () => {
    if (totalSteps <= 1) return null;

    const steps = [];
    for (let i = 1; i <= totalSteps; i++) {
      steps.push(
        <div
          key={i}
          className={`step ${i === currentStep ? 'active' : ''} ${i < currentStep ? 'completed' : ''}`}
        >
          {i}
        </div>
      );
      if (i < totalSteps) {
        steps.push(<div key={`line-${i}`} className="step-line"></div>);
      }
    }
    return <div className="stepper">{steps}</div>;
  };

  return (
    <div className="dark-form-wrapper">
      <div className="form-header">
        <h1>{title}</h1>
        <p>{subtitle}</p>
      </div>

      {renderStepper()}

      <div className="form-content">
        {children}
      </div>
    </div>
  );
};

export default FormWrapper;